import React, { useCallback, useEffect, useState } from "react";
import { audioIconLabels } from "@constants/consts";
import audioPlayerManager from "../../AudioPlayerManager/AudioPlayerManager";
import * as Styled from "./IconSection.styled";

export const volumeIconDataTestId = "volumeIconDataTestId";
export const volumeMutedIconDataTestId = "volumeMutedIconDataTestId";
export const volumeBarDataTestId = "volumeBarDataTestId";

const IconWrapper: React.FC<{ label: string; inAudioDashboard: boolean; children: React.ReactNode }> = ({
  label,
  children,
  inAudioDashboard,
}) => {
  return inAudioDashboard ? (
    <Styled.IconWrapper>
      {children}
      <Styled.IconLabel>{label}</Styled.IconLabel>
    </Styled.IconWrapper>
  ) : (
    children
  );
};

const IconSection = ({ inAudioDashboard = false }: { inAudioDashboard?: boolean }) => {
  const [currentVolume, setCurrentVolume] = useState({ volume: 0.5 });
  const [preMuteVolume, setPreMuteVolume] = useState(1);

  useEffect(() => {
    audioPlayerManager.on("playerVolume", setCurrentVolume);
    return () => {
      audioPlayerManager.off("playerVolume", setCurrentVolume);
    };
  }, []);

  const handleVolumeMute = useCallback(() => {
    if (currentVolume.volume) {
      setPreMuteVolume(currentVolume.volume);
      setCurrentVolume({ volume: 0 });
      audioPlayerManager.mute();
      return;
    }
  }, [currentVolume.volume]);

  return (
    <Styled.IconSectionContainer>
      <IconWrapper label={audioIconLabels.VIDEO_ICON} inAudioDashboard={inAudioDashboard}>
        <Styled.StyledVideoIcon />
      </IconWrapper>
      <IconWrapper label={audioIconLabels.WHATSAPP_ICON} inAudioDashboard={inAudioDashboard}>
        <Styled.StyledWhatsAppIcon />
      </IconWrapper>
      <IconWrapper label={audioIconLabels.VOLUME_ICON} inAudioDashboard={inAudioDashboard}>
        <Styled.VolumeControlsContainer>
          {!!currentVolume.volume && (
            <Styled.VolumeIcon onClick={handleVolumeMute} data-testid={volumeIconDataTestId} />
          )}
          <Styled.VolumeMutedIcon
            onClick={() => audioPlayerManager.volumeChange(preMuteVolume)}
            isVolumeMuted={!currentVolume.volume}
            data-testid={volumeMutedIconDataTestId}
          />
          <Styled.VolumeBarContainer>
            <Styled.VolumeBar
              type="range"
              min={0}
              max={1}
              step={0.01}
              value={currentVolume.volume}
              volumePercentage={`${(currentVolume.volume * 100).toString()}%`}
              onChange={(event) => audioPlayerManager.volumeChange(Number(event.target.value))}
              data-testid={volumeBarDataTestId}
            />
          </Styled.VolumeBarContainer>
        </Styled.VolumeControlsContainer>
      </IconWrapper>
      <IconWrapper label={audioIconLabels.POP_OUT_ICON} inAudioDashboard={inAudioDashboard}>
        <Styled.StyledPopOutIcon />
      </IconWrapper>
    </Styled.IconSectionContainer>
  );
};

export default IconSection;
